import { useState } from "react";
import { Star } from "@phosphor-icons/react";

export function StarDisplay({ value = 0, size = 16, testId, dark = false }) {
  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testId} aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          weight={value >= i - 0.25 ? "fill" : value >= i - 0.75 ? "duotone" : "regular"}
          className={value >= i - 0.75 ? "text-[#C84A31]" : dark ? "text-white/40" : "text-[#1C211E]/25"}
        />
      ))}
    </div>
  );
}

const LABELS = ["", "Snagged", "Meh catch", "Decent haul", "Great catch", "Trophy fish"];

export function StarInput({ value, onChange }) {
  const [hover, setHover] = useState(0);
  const shown = hover || value;
  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-1" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((i) => (
          <button
            key={i}
            type="button"
            data-testid={`star-input-${i}`}
            aria-label={`${i} star${i > 1 ? "s" : ""}`}
            onMouseEnter={() => setHover(i)}
            onClick={() => onChange(i)}
            className="p-0.5 transition-transform duration-150 hover:scale-125 active:scale-95"
          >
            <Star size={30} weight={shown >= i ? "fill" : "regular"} className={shown >= i ? "text-[#C84A31]" : "text-[#1C211E]/30"} />
          </button>
        ))}
      </div>
      <span data-testid="star-input-label" className="text-sm font-display text-foreground/70">{LABELS[shown] || "Tap to rate"}</span>
    </div>
  );
}
